
<div class="modal-header">{{connection.name}}</div>
<div class="modal-body">
  <div class="text-center text-info" *ngIf="step == &quot;done&quot;">
    <div><i class="far fa-ellipsis-h fa-3x"></i></div>
    <div translate>Almost done</div>
    <translate class="text-muted">Select a gallery to complete the upload</translate><br>
  </div>
  <div class="text-center text-success" *ngIf="step == &quot;saved&quot;">
    <div><i class="far fa-check fa-3x"></i></div>
    <div translate>Click Upload complete</div><br>
  </div>
  <div class="list-group mb-4" *ngIf="step == &quot;uploading&quot;">
    <div class="list-group-item d-flex align-items-center" *ngIf="currentAsset" [title]="currentAsset.displayName">
      <asset-thumbnail class="sm mr-3" [asset]="currentAsset"></asset-thumbnail>
      <div class="w-100">
        <div class="no-wrap">{{currentAsset.displayName}}</div>
        <div class="no-wrap">
          <smart-progress [max]="assets.length" [value]="uploadedCount + 1" text="Uploading {{uploadedCount + 1}} of {{assets.length}}"></smart-progress>
        </div>
      </div>
    </div><a class="list-group-item list-group-item-action d-flex align-items-center" (click)="notifyOnCompletion = !notifyOnCompletion" [class.active]="notifyOnCompletion"><i class="far fa-2x fa-fw fa-bell" *ngIf="!notifyOnCompletion"></i><i class="far fa-2x fa-fw fa-check text-info" *ngIf="notifyOnCompletion"></i>
      <div class="ml-2"><strong translate>Notify me when the upload is complete</strong>
        <div translate>Sends a notification according to your notification settings.</div>
      </div></a>
  </div>
  <div *ngIf="connection">
    <div *ngIf="!gallery &amp;&amp; galleries">
      <h3 translate>Select or create a gallery</h3>
      <spinner *ngIf="galleriesLoading"></spinner>
      <filterbox [(ngModel)]="galleriesFilter" *ngIf="galleries.length &gt; 0"></filterbox>
      <div class="list-group" *ngIf="!galleriesLoading"><a class="list-group-item list-group-item-action" (click)="selectGallery(null)"><i class="far fa-fw fa-plus"></i>
          <translate>Create a new gallery</translate></a><a class="list-group-item list-group-item-action" *ngFor="let gallery of galleries|naturalOrderBy:&quot;name&quot;|filterBy:[&quot;name&quot;]:galleriesFilter" (click)="selectGallery(gallery)"><i class="far fa-fw fa-folder"></i><span>{{gallery.name}}</span></a></div>
    </div>
    <div *ngIf="gallery"><br>
      <h3 translate>Selected gallery</h3>
      <div class="form-group">
        <div class="list-group-item combi double">
          <div class="list-group-main d-flex align-items-center" [title]="gallery.name"><i class="far fa-2x fa-fw fa-folder-open mr-3"></i>
            <div class="no-wrap"><strong translate>Gallery</strong>
              <div class="no-wrap">{{gallery.name}}</div>
            </div>
          </div><a class="btn btn-link" [href]="gallery.presignedLoginUrl" target="_blank" [title]="&quot;View gallery&quot;|translate"><i class="far fa-external-link"><span class="sr-only" translate>View gallery</span></i></a>
        </div>
      </div><br>
      <h3 translate>Links</h3>
      <ng-container *ngFor="let link of links">
        <div class="mb-4" *ngIf="links.length &gt; 0">
          <div class="form-control-static no-wrap"><i class="icon-link"></i>&nbsp;<span *ngIf="!link.elementsUser?.email">Link</span><span *ngIf="link.elementsUser?.email">{{link.elementsUser.email}}</span><span class="text-muted" *ngIf="link.viewsLeft == null">&nbsp; - &nbsp;
              <translate>Unlimited views</translate></span><span class="text-muted" *ngIf="link.viewsLeft != null">&nbsp; - &nbsp;
              <translate>{{link.viewsLeft}} views left</translate></span></div>
          <div class="d-flex align-items-center">
            <input class="form-control" type="text" readonly value="{{connection.url}}/link/{{link.secretKey}}" autoselect [srLabel]="&quot;link&quot;|translate">
            <button class="btn btn-secondary" (click)="deleteLink(link)"><i class="far fa-trash-alt"><span class="sr-only" translate>Delete</span></i></button>
          </div>
        </div>
      </ng-container>
      <button class="btn btn-secondary" (click)="createLink()"><i class="far fa-link"></i>
        <translate>Create a link</translate>
      </button>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" [clickBlocking]="background" [disabled]="!gallery?.id" *ngIf="step == &quot;uploading&quot;" translate>Continue in background</button>
  <button class="btn btn-outline-secondary" (click)="abort()" *ngIf="step != &quot;saved&quot;" translate>Cancel</button>
  <button class="btn btn-outline-secondary" (click)="close()" *ngIf="step == &quot;saved&quot;" translate>Close</button>
</div>